var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "module-component-wrapper" }, [
    _vm.showOfferContentBox
      ? _c("div", { staticClass: "module-component-wrapper__left" }, [
          _c("div", { staticClass: "what" }, [
            _c("div", [
              _c("div", { staticStyle: { width: "25%", float: "left" } }, [
                _c("img", {
                  staticStyle: { width: "90%" },
                  attrs: { src: _vm.description1.img1 },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { width: "70%", float: "left" } }, [
                _c("h2", { staticStyle: { "font-weight": "900" } }, [
                  _vm._v(_vm._s(_vm.$t("module.purpose"))),
                ]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.description1.p1))]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.description1.p2))]),
                _vm._v(" "),
                _vm.description1.p3
                  ? _c("p", [_vm._v(_vm._s(_vm.description1.p3))])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm.knowMoreLink !== "#"
              ? _c(
                  "a",
                  {
                    staticClass: "offer-wrapper__btn",
                    staticStyle: { "margin-left": "25%" },
                    attrs: { href: _vm.knowMoreLink, target: "_blank" },
                  },
                  [_vm._v(_vm._s(_vm.$t("module.knowMore")))]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "how" }, [
            _c("div", [
              _c("div", [
                _c("h2", { staticStyle: { "font-weight": "900" } }, [
                  _vm._v(_vm._s(_vm.$t("module.howItWorks"))),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.description2.p1) +
                      "\n            "
                  ),
                  _vm.description2.p1List1
                    ? _c("span", [
                        _c("br"),
                        _vm._v("- " + _vm._s(_vm.description2.p1List1)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.description2.p1List2
                    ? _c("span", [
                        _c("br"),
                        _vm._v("- " + _vm._s(_vm.description2.p1List2)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.description2.p1List3
                    ? _c("span", [
                        _c("br"),
                        _vm._v("- " + _vm._s(_vm.description2.p1List3)),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.description2.p2))]),
                _vm._v(" "),
                _vm.description2.p3
                  ? _c("p", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.description2.p3) +
                          "\n            "
                      ),
                      _vm.description2.p3List1
                        ? _c("span", [
                            _c("br"),
                            _vm._v("- " + _vm._s(_vm.description2.p3List1)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.description2.p3List2
                        ? _c("span", [
                            _c("br"),
                            _vm._v("- " + _vm._s(_vm.description2.p3List2)),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm.demoLink !== "#"
              ? _c(
                  "a",
                  {
                    staticClass: "offer-wrapper__btn",
                    attrs: { href: _vm.demoLink, target: "_blank" },
                  },
                  [_vm._v(_vm._s(_vm.$t("module.demo")))]
                )
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showOfferContentBox
      ? _c("div", { staticClass: "module-component-wrapper__right" }, [
          _c("div", { staticClass: "offer-wrapper" }, [
            _c("div", { staticClass: "offer-wrapper__content" }, [
              _c(
                "div",
                [
                  _vm._v("\n          " + _vm._s(_vm.$t("offers.from")) + " "),
                  _c("br"),
                  _vm._v(" "),
                  _c("h3", [
                    _vm._v(
                      _vm._s(_vm.$t("offers.singleOffer")) +
                        " " +
                        _vm._s(_vm.level)
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "offer-wrapper__btn",
                      staticStyle: { float: "right" },
                      attrs: { to: "/settings/offers" },
                    },
                    [_vm._v(_vm._s(_vm.$t("module.seeOffer")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [
                _vm.isPremium
                  ? _c("span", {
                      staticClass: "pictoBtn",
                      domProps: { innerHTML: _vm._s(_vm.pictoPremium) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isStandard
                  ? _c("span", {
                      staticClass: "pictoBtn",
                      domProps: { innerHTML: _vm._s(_vm.pictoStandard) },
                    })
                  : _vm._e(),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "example" }, [
            _c("div", [
              _c("div", [
                _c("img", {
                  staticStyle: { width: "100%" },
                  attrs: { src: _vm.description3 },
                }),
              ]),
              _vm._v(" "),
              _vm.image4
                ? _c("div", [
                    _c("img", {
                      staticStyle: { width: "100%" },
                      attrs: { src: _vm.image4 },
                    }),
                  ])
                : _vm._e(),
            ]),
          ]),
        ])
      : _c("div", { staticClass: "access-denied-standard-wrapper" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/img/forbidden_access_icon.png"),
              alt: "accès interdit",
            },
          }),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n      " + _vm._s(_vm.$t("module.forbidden")) + "\n    "),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }